import z from "zod/v4";
import { RealmId } from "./realm-id";

/** Zod schema for RealmId string representation (e.g., "R01", "RFF") */
export const RealmIdSchema = z
  .string()
  .regex(/^R[0-9A-Fa-f]{2}$/, "Must be R followed by two hex digits")
  .transform((s) => RealmId.fromString(s));

export const RealmIdCodec = z.codec(
  z.string(),
  z.custom<RealmId>(() => true),
  {
    decode: (encoded) => RealmId.fromString(encoded),
    encode: (decoded) => RealmId.toString(decoded),
  },
);
